// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"placeholder_wrapper__3c574","placeholder":"placeholder_placeholder__V8axT"};